// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToTopButton_button__YkE1Z"};